export default "__VITE_ASSET__CPJw2Rdu__"